import { FC } from 'react';
import OperationButton from './operationButton';
import Add from './add';
import AddGroup from './addGroup';
import DeleteIcon from './deleteIcon';
import Delete from './delete';
import Sync from './sync';
import Detail from './detail';
import Edit from './edit';
import Import from './import';
import Export from './export';
import Batch from './batch';
import Close from './close';
import Cancel from './cancel';
import Start from './start';
import Stop from './stop';
import Drafts from './drafts';
import Print from './print';
import Submit from './submit';
import Examine from './examine';
import Adopt from './adopt';
import Complete from './complete';
import Notice from './notice';
import Lock from './lock';
import UnLock from './unLock';
import Bind from './bind';
import Search from './search';
import Invalid from './invalid';
import Settlement from './settlement';
import Reject from './reject';
import PlaceOrder from './placeOrder';
import End from './end';
import Download from './download';
import Next from './next';
import Prev from './prev';
import BatchGroup from './batchGroup';
import Reset from './reset';
import Dropdown from './dropdown';
import {
  BaseOperationButtonProps,
  BaseOperationButtonGroupProps,
  BaseIconButtonProps,
  BaseBatchButtonGroupProps,
  BaseOperationDropdownProps,
} from './interface';

export type IOperationButtonComponent = FC<BaseOperationButtonProps> & {
  /** 新增按钮 */
  Add: FC<BaseOperationButtonProps>;
  /** 新增按钮组 */
  AddGroup: FC<BaseOperationButtonGroupProps>;
  /** 删除按钮 */
  Delete: FC<BaseOperationButtonProps>;
  /** 同步按钮 */
  Sync: FC<BaseOperationButtonProps>;
  /** 查看按钮 */
  Detail: FC<BaseOperationButtonProps>;
  /** 编辑按钮 */
  Edit: FC<BaseOperationButtonProps>;
  /** 导入按钮 */
  Import: FC<BaseOperationButtonProps>;
  /** 导出按钮 */
  Export: FC<BaseOperationButtonProps>;
  /** 批量操作按钮 */
  Batch: FC<BaseOperationButtonProps>;
  /** 关闭按钮 */
  Close: FC<BaseOperationButtonProps>;
  /** 取消按钮 */
  Cancel: FC<BaseOperationButtonProps>;
  /** 开启按钮 */
  Start: FC<BaseOperationButtonProps>;
  /** 暂停按钮 */
  Stop: FC<BaseOperationButtonProps>;
  /** 草稿箱按钮 */
  Drafts: FC<BaseOperationButtonProps>;
  /** 打印按钮 */
  Print: FC<BaseOperationButtonProps>;
  /** 提交按钮 */
  Submit: FC<BaseOperationButtonProps>;
  /** 审核按钮 */
  Examine: FC<BaseOperationButtonProps>;
  /** 通过按钮 */
  Adopt: FC<BaseOperationButtonProps>;
  /** 完成按钮 */
  Complete: FC<BaseOperationButtonProps>;
  /** 通知按钮 */
  Notice: FC<BaseOperationButtonProps>;
  /** 锁定按钮 */
  Lock: FC<BaseOperationButtonProps>;
  /** 解锁按钮 */
  UnLock: FC<BaseOperationButtonProps>;
  /** 绑定按钮 */
  Bind: FC<BaseOperationButtonProps>;
  /** 搜索按钮 */
  Search: FC<BaseOperationButtonProps>;
  /** 结算按钮 */
  Settlement: FC<BaseOperationButtonProps>;
  /** 作废按钮 */
  Invalid: FC<BaseOperationButtonProps>;
  /** 驳回按钮 */
  Reject: FC<BaseOperationButtonProps>;
  /** 完结按钮 */
  PlaceOrder: FC<BaseOperationButtonProps>;
  /** 下单按钮 */
  End: FC<BaseOperationButtonProps>;
  /** 下载按钮 */
  Download: FC<BaseOperationButtonProps>;
  /** 上一步按钮 */
  Next: FC<BaseOperationButtonProps>;
  /** 下一步按钮 */
  Prev: FC<BaseOperationButtonProps>;
  /** 批量按钮组 */
  BatchGroup: FC<BaseBatchButtonGroupProps>;
  /** 删除图标 */
  DeleteIcon: FC<BaseIconButtonProps>;
  /** 重置按钮 */
  Reset: FC<BaseOperationButtonProps>;
  /** dropdown按钮组 */
  Dropdown: FC<BaseOperationDropdownProps>;
};
/** 操作按钮 */
const TransOperationButton = OperationButton as IOperationButtonComponent;
TransOperationButton.Add = Add;
TransOperationButton.AddGroup = AddGroup;
TransOperationButton.Delete = Delete;
TransOperationButton.Sync = Sync;
TransOperationButton.Detail = Detail;
TransOperationButton.Edit = Edit;
TransOperationButton.Import = Import;
TransOperationButton.Export = Export;
TransOperationButton.Batch = Batch;
TransOperationButton.Close = Close;
TransOperationButton.Cancel = Cancel;
TransOperationButton.Start = Start;
TransOperationButton.Stop = Stop;
TransOperationButton.Drafts = Drafts;
TransOperationButton.Print = Print;
TransOperationButton.Submit = Submit;
TransOperationButton.Examine = Examine;
TransOperationButton.Adopt = Adopt;
TransOperationButton.Complete = Complete;
TransOperationButton.Notice = Notice;
TransOperationButton.Lock = Lock;
TransOperationButton.UnLock = UnLock;
TransOperationButton.Bind = Bind;
TransOperationButton.DeleteIcon = DeleteIcon;
TransOperationButton.Search = Search;
TransOperationButton.Settlement = Settlement;
TransOperationButton.Invalid = Invalid;
TransOperationButton.Reject = Reject;
TransOperationButton.PlaceOrder = PlaceOrder;
TransOperationButton.End = End;
TransOperationButton.Download = Download;
TransOperationButton.Next = Next;
TransOperationButton.Prev = Prev;
TransOperationButton.BatchGroup = BatchGroup;
TransOperationButton.Reset = Reset;
TransOperationButton.Dropdown = Dropdown;

export default TransOperationButton;
